import { LinkId } from '../../../AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../AnalyticsContext/applyTrackingId';
import { returnVoid } from '../../../util/returnVoid';
import { Hamburger } from './HamburgerIcon.styles';

interface Props {
  onClick?: VoidFunction;
  className?: string;
}

export const HamburgerIcon = ({ onClick = returnVoid, className }: Props) => (
  <Hamburger
    onClick={onClick}
    className={className}
    {...applyTrackingId(LinkId.MOBILE_HAMBURGER_BUTTON)}
  />
);
